import * as React from 'react';

import { useIORef } from '../core/hooks';

interface ISelectContext {
    focused: boolean,
    focus: (onFocus?: (e: React.FocusEvent) => void) => (e: React.FocusEvent) => void,
    blur: (onBlur?: (e: React.FocusEvent) => void) => (e: React.FocusEvent) => void,
    strongFocus: () => void,
    strongBlur: () => void,
}

const SelectContext = React.createContext<ISelectContext>({
    focused: false,
    focus: () => () => { console.warn('Подключи провайдер множественного фокуса') },
    blur: () => () => { console.warn('Подключи провайдер множественного фокуса') },
    strongFocus: () => {},
    strongBlur: () => {},
});


export const MultipleFocus: React.FunctionComponent = ({ children }) => {

    const [focused, setFocused] = React.useState(false);
    
    const { read: isFocused, write } = useIORef(false);

    const focusin = write(true);
    const blurin = write(false);

    const focus = (onFocus?: (e: React.FocusEvent) => void) => 
        (e: React.FocusEvent) => {
            if(!isFocused()){
                focusin();
                setFocused(true);
                if(onFocus){
                    onFocus(e);
                }
            }
        }

    const blur = (onBlur?: (...x: any[]) => void) => {

        return (e: React.FocusEvent) => {
            // @ts-ignore

            // console.log({
            //     foo: e.currentTarget,
            //     bar: e.target,
            //     loo: e.relatedTarget,
            //     foobar: e.nativeEvent.currentTarget,
            //     foosuka: e.nativeEvent.relatedTarget,
            // });
            // if(e.currentTarget.contains(e.target)){
            //     return;
            // }
            if(e.currentTarget.contains(e.nativeEvent.relatedTarget)){
                return;
            }

            blurin();

            setTimeout(() => {
                if(!isFocused()){
                    setFocused(false);
                    if(onBlur){
                        onBlur(e);
                    }
                }
            }, 0);
        }
    }

    const strongFocus = () => {
        focusin();
        setFocused(true);
    }

    const strongBlur = () => {
        blurin();
        setFocused(false);
    }

    return (
        <SelectContext.Provider value={{
            focused,
            focus,
            blur,
            strongFocus,
            strongBlur,
        }}>
            {children}
        </SelectContext.Provider>
    );
}

export const useFocusContext = () => {
    return React.useContext(SelectContext);
}

export const connectFocus: <T>(Component: React.FunctionComponent<T>) => React.FunctionComponent<T & React.HTMLAttributes<HTMLElement>> = 
    (Component) => React.memo((props) => {

        const { focus, blur, focused } = React.useContext(SelectContext);

        return (
            <Component
                tabIndex={0}
                onFocus={focus}
                onBlur={blur}
                focused={focused}
                {...props}
            />
        );
    });
